import Loadable from 'react-loadable'
import React from 'react'
export default Loadable({
  loader: () => import('./index.js'),
  loading: () => <h1>Loading....</h1>,
})
